import React from 'react';

import styles from './NewsPage.module.css';

type TProps = {
  children: React.ReactNode;
};

export const NewsPageTemplate = ({ children }: TProps) => (
  <div className={styles.NewsPage__Template}>{children}</div>
);
